import {ComboOption, DataInput} from "../models/DataCollectionPaneConfig";
import {settings} from "../../../../settings/settings-util";
import {VTree} from "virtual-dom";
import h from "virtual-dom/h";
import {buildLabelText} from "./Label";
import {buildErrorMessages} from "./ErrorMessages";

type StringDictionary = {[key: string]: string};

const buildComboOptions = (options: ComboOption[] | undefined): VTree[] =>
{
    return options?.map((option) =>
    {
        const attributes = { value: option.value } as StringDictionary;
        if (option?.selected === 'true') { attributes.selected = 'true'; }

        return h('option', { attributes }, option.text);
    }) ?? [];
};

const buildComboBox = (input: DataInput, dataInputs: DataInput[], passedSettings: typeof settings, onInput: () => void, onBlur: () => void): VTree[] =>
{

    const comboParams =
    {
        id: input.id,
        className: passedSettings.classNames.dataCollectionPaneComboBox,
        required: input.required === 'true',
        oninput: onInput,
        onblur: onBlur,
    };
    const lastElementID = dataInputs[dataInputs.length - 1].id;
    const labelText = buildLabelText(input, passedSettings.classNames);
    const select = h('select', comboParams, buildComboOptions(input.options));
    const errors = buildErrorMessages(input, passedSettings);
    const className = passedSettings.classNames.dataCollectionPaneComboLabel;
    if(input.id === lastElementID)
    {
        const label = h('label', { className }, [...labelText, select, errors]);
        return [label];
    }
    else
    {
        const label = h('label', { className }, [...labelText, select]);
        return [label];
    }
    
};

export {buildComboBox, buildComboOptions};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/elements/ComboBox.ts